// Redux stuff
import { connect } from 'react-redux';
import { resetChoices } from '../actions/choicesActions';

// ui
import TableControls from './TableControls';

const mapStateToProps = state => {

    return {
        hasChoices: Object.values(state.choices).length
    };
};

const mapDispatchToProps = dispatch => {
    return {
        resetChoices: () => { dispatch(resetChoices()); }
    };
};

/**
  * Redux container for the TableControls component
  *
  */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableControls);